import React from "react";

const Announcement = () => {
  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "800px",
        margin: "20px auto",
        backgroundColor: "#43555e",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#e91e63" }}>
        📢 Matangazo Muhimu
      </h2>

      <ul style={{ lineHeight: "1.8", fontSize: "16px" }}>
        <li>🎁 Bonasi za mwaliko zinapatikana mara baada ya rafiki kujiunga Na kuweka amana nakuomba bonus Maana yake unapo mualika rafiki rafiki aishaa weka pesa basi ana tembelea page ya Promotions.</li>
        <li>Hivyo basi akishaa Applay bonus basi ndipo na wewe unapo pata bonus ya asilimia 10%  </li>
        <li>⚽ Mechi mpya huongezwa kila siku saa 12 jioni.</li>
        <li>💸 Malipo ya ushindi hufanyika ndani papo hapo baada ya mchezo kumalizika. Hvyo match uchezwa dk90 nazikimalizika unapokea pesa papo hapo[].</li>
        <li>📲 Tafadhali jiunge na group letu rasmi kwa masasisho mapya.</li>
        <li>⏰ Kumbuka muda wa mechi — ukiukosa hautahesabiwa.</li>
      </ul>

      <p style={{ marginTop: "15px", fontStyle: "italic", color: "#333" }}>
        🔔 Kila tangazo hapa ni nafasi yako ya kupata zaidi. Usipitwe na habari
        mpya!  
      </p>

      <p style={{ marginTop: "10px", fontWeight: "bold", color: "#4caf50" }}>
        🚀 “Kila siku mpya ni nafasi ya ushindi mpya — kaa macho na FES!”
      </p>
    </div>
  );
};

export default Announcement;